import Page from '../components/Page';
import Hero from '../components/Hero';
import ProjectSection from '../components/ProjectSection';
import Image from '../components/Image';
import { SITE_ORIGIN, site, projects } from '../content';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: site.person,
    jobTitle: site.jobTitle,
    url: SITE_ORIGIN,
    sameAs: [site.linkedin],
  };

  return (
    <Page seo={site.seo} jsonLd={jsonLd}>
      <Hero
        id="home"
        data={{
          'data-bg': 'var(--color-tertiary-a)',
          'data-color': 'var(--color-tertiary-b)',
          'data-highlight': 'var(--color-primary)',
          'data-highlight-color': 'var(--color-secondary)',
        }}
        video={{ src: site.home.hero.video, playbackRate: 0.7 }}
      >
        <div className="contain container-lg">
          <div className="flex flex-wrap">
            <div className="w-full md:w-1/2 lg:w-3/4">
              <div className="hero-intro">
                <div className="context mb-2">{site.home.hero.context}</div>
                <h1 className="display">{site.home.hero.title}</h1>
                <p className="intro">{site.home.hero.intro}</p>
              </div>
            </div>
          </div>
        </div>
      </Hero>

      <section
        id="about"
        className="region section section-screen-h section-valign text-center theme"
        data-bg="var(--color-primary)"
        data-color="var(--color-tertiary-b)"
        data-highlight="var(--color-tertiary-a)"
        data-highlight-color="var(--color-secondary)"
        data-start="late"
      >
        <article className="section-inner-large section-inner-pad">
            <div className="contain container-fluid container-limit">
            <div className="flex flex-wrap justify-center">
              <div className="w-full sm:w-2/3 xl:w-7/12">
                <header>
                  <h1 className="display">{site.home.about.title}</h1>
                  <p className="intro">{site.home.about.intro}</p>
                </header>
              </div>
            </div>
            <div className="flex flex-wrap justify-center">
              <div className="w-3/4">
                <div id="stats" data-visible-callback="MAIN.count">
                  {site.home.about.stats.map((stat) => (
                    <div className="stat" key={stat.label}>
                      <div className="figure">
                        <span className="count" data-count-target={stat.value}>0</span>
                        {stat.suffix || null}
                      </div>
                      <div className="label">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </article>
      </section>

      <section
        id="services"
        className="region section section-screen-h section-valign text-center theme"
        data-bg="var(--color-tertiary-a)"
        data-color="var(--color-tertiary-b)"
        data-highlight="var(--color-primary)"
        data-highlight-color="var(--color-secondary)"
      >
        <article className="section-inner-large section-inner-pad">
            <div className="contain container-fluid container-limit">
            <div className="flex flex-wrap justify-center">
              <div className="w-full sm:w-2/3">
                <header>
                  <div className="context mb-2">{site.home.services.context}</div>
                  <h1 className="display">{site.home.services.title}</h1>
                  <p className="intro">{site.home.services.intro}</p>
                </header>
              </div>
            </div>
            <div className="flex flex-wrap justify-evenly mt-5 gap-x-12 gap-y-12">
              {site.home.services.items.map((item, index) => (
                <div className="w-full lg:w-auto content-visible" key={item.title}>
                  <div className={`usp-item item-${index + 1} text-left`}>
                    <h2 className="h4">{item.title}</h2>
                    <ul className="list-text">
                      {item.items.map((line) => (
                        <li key={line}>{line}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </article>
      </section>

      <section
        id="clients"
        className="region section text-center theme"
        data-bg="var(--color-secondary)"
        data-color="var(--color-tertiary-a)"
        data-highlight="var(--color-primary)"
        data-highlight-color="var(--color-secondary)"
      >
        <article>
          <div className="container px-0">
            <h1>{site.home.clients.title}</h1>
            <div className="client-grid">
              {site.home.clients.logos.map((logo) => (
                <div className="grid-item" key={logo.alt}>
                  <Image src={logo.src} alt={logo.alt} className="max-w-full h-auto" />
                </div>
              ))}
            </div>
          </div>
        </article>
      </section>

      <ProjectSection featured={site.home.work.featured} projects={projects} />
    </Page>
  );
}
